<script>
import {mapGetters} from 'vuex'
import Settings from '../../../mixins/edit/Settings';

export default {
    name: 'create-landing-page-settings',
    mixins: [Settings],
    data()
    {
        return {
            action:
            {
                update: 'landingPageUpdate',
            },
            subPageName: 'landing-page-subpages',
            id: 'page_id',
        }
    },
}
</script>
<template lang="html">
    <div >
        <div class="py-5 border-sides-1-secondary border-bottom-1-secondary" >
            <div class="px-3">
                <div class="row mb-3">
                    <div class="col-2 text-right pt-2 font-weight-bold">
                        Signup Page URL
                    </div>
                    <div class="col-10">
                        <simple-input
                        type="text"
                        :preText="startUrl"
                        v-model="item.url"
                        placeholder="Add hosted url"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        Page title
                    </div>
                    <div class="col-10">
                        <simple-input
                        type="text"
                        v-model="item.meta.title"
                        placeholder="Type a headline"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-2"></div>
                    <div class="col-10 text-desc-color text-sm">
                        <span v-if="item.meta.title">
                            {{ 70-item.meta.title.length }} characters left
                        </span>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        Page description
                    </div>
                    <div class="col-10">
                        <simple-input
                        type="textarea"
                        rows="2"
                        v-model="item.meta.description"
                        placeholder="Type a headline"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-2"></div>
                    <div class="col-10 text-desc-color text-sm">
                        <span v-if="item.meta.description">
                            {{ 255-item.meta.description.length}} characters left
                        </span>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        Keywords
                    </div>
                    <div class="col-10">
                        <simple-input
                        type="textarea"
                        rows="2"
                        v-model="item.meta.keywords"
                        placeholder="Type a headline"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-2"></div>
                    <div class="col-10 text-desc-color text-sm">
                        <span v-if="item.meta.keywords">
                            {{ 255-item.meta.keywords.length }} characters left
                        </span>
                    </div>
                </div>
            </div>
            <div class="px-3 border-top-1-secondary pt-4">
                <div class="row">
                    <div class="col-2"></div>
                    <div class="col-9">
                        <div class="border border-radius-4-top">
                            <table class="create-offer-fields">
                                <thead>
                                    <tr class="border-radius-4-top">
                                        <th colspan="2">
                                            Select data fields to collect
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-if="fields">
                                    <tr v-for="(field, index) in fields" :class="{'grey-bg': !item.name}">
                                        <td style="width:10%;vertical-align: top" class="text-center">
                                            <switcher
                                                class="d-inline-block mr-2"
                                                @input="setField($event, field)"
                                                :value="item.fields.getBy('id', field.id).id"
                                            ></switcher>
                                        </td>
                                        <td style="width:90%">
                                            <strong>{{ field.label }} ({{ field.name }})</strong> <br>
                                            <template v-if="item.fields.getBy('id', field.id).id">
                                                <div class="my-3">
                                                    <simple-input
                                                    type="text"
                                                    :value="getPivotField(field, 'class')"
                                                    @input="setPivotField($event, field, 'class')"
                                                    placeholder="Class of the input field"
                                                    noRadius
                                                    ></simple-input>
                                                </div>
                                                <simple-input
                                                type="number"
                                                :value="getPivotField(field, 'order')"
                                                @input="setPivotField($event, field, 'order')"
                                                placeholder="Order of the input field"
                                                noRadius
                                                ></simple-input>
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grey-bg border-bottom-1-secondary border-sides-1-secondary px-3 py-2">
            <div class="row">
                <div class="col-12 text-right">
                    <custom-button classes="white text-desc-color w-120" text="Discard" @buttonClick="discard"></custom-button>
                    <custom-button classes="blue text-white w-120" text="Save" @buttonClick="save"></custom-button>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/landingpages/edit/Settings.vue